// Companion to the ends-with action selectors in action_link.ts: an ends-with
// selector survives href decoration (marketing tags prepend an absolute URL and
// query string in front of the fragment), but it also matches a genuine link to
// a DIFFERENT page that happens to end in the action fragment. This rejects
// those: a decorated href counts as our action only if it still points at the
// current document.
export function matchesAction(element: Element, action: string): boolean {
  const link = element.getAttribute('data-element-link')
  if (link !== null) return link === action

  // The browser resolves an anchor's href for us — no URL parsing, and a malformed
  // href yields an empty hash rather than a throw mid-dispatch.
  const { hash, origin, pathname } = element as HTMLAnchorElement
  return hash === action && origin === window.location.origin && pathname === window.location.pathname
}
